<!-- Outgoing call handler popup -->
<div class="video-call" id="outgoing-popup" *ngIf="call.outgoingCall">
    <div class="call-popup p-5 dark">
        <div class="user-img d-flex justify-content-center">
            <img
                    src="assets/images/chat/popup-images/group-icon.png"
                    alt="group icon"
            />
        </div>
        <div class="c-name mt-2 text-center">
            <ng-container *ngIf="call.groupName">
                <p className="mb-0" [innerHTML]="call.groupName"></p>
            </ng-container>
            <p class="mt-3 mb-0 d-flex justify-content-center align-items-center">
                <mat-icon>videocam</mat-icon>
                &nbsp; Calling...
            </p>
        </div>
        <div class="call-btns">
            <button mat-raised-button color="warn" (click)="this.endCall()">
                <mat-icon>call_end</mat-icon>
                End Call
            </button>
        </div>
    </div>
</div>
<!-- End outgoing call handler popup -->

<!-- Incoming call handler popup -->
<div class="video-call" *ngIf="notification.videoCall">
    <div class="call-popup p-5 dark">
        <div class="user-img d-flex justify-content-center">
            <img
                    src="assets/images/chat/popup-images/group-icon.png"
                    alt="group icon"
            />
        </div>
        <div class="c-name mt-2 text-center">
            <span>{{ notification.videoCallData?.groupName }}</span>
            <p
                    class="mt-3 mb-0 d-flex justify-content-center align-items-center text-nowrap"
            >
                <mat-icon>videocam</mat-icon>
                &nbsp;Incoming video call...
            </p>
        </div>
        <div class="d-flex justify-content-around align-items-center mt-3">
            <button mat-mini-fab class="reject-call" (click)="rejectCall()">
                <mat-icon>call_end</mat-icon>
            </button>
            <button mat-mini-fab class="pick-up-call" (click)="acceptCall()">
                <mat-icon>call</mat-icon>
            </button>
        </div>
    </div>
</div>
<!-- End incoming call handler popup -->

<!-- Who is joining call popup -->
<div class="video-call" *ngIf="call.whoIsJoined">
    <div class="call-popup p-5">
        <div class="user-img d-flex justify-content-center">
            <img
                    src="assets/images/chat/popup-images/group-icon.png"
                    alt="group icon"
            />
        </div>
        <div class="d-flex justify-content-around align-items-center mt-3">
            <button mat-raised-button class="reject-call text-white rounded-pill">
                {{ call.whoIsJoined }} is Connecting...
            </button>
        </div>
    </div>
</div>

<!-- START -->
<div class="media-progress refer-info upload-info attachment-info"
     *ngIf="importingState.showImporting">
    <p-accordion class="custom-accordion progress-accordion"
                 [multiple]="true"
                 activeIndex="0">
        <p-accordionTab class="media-header" [transitionOptions]="'100ms'">
            <p-header class="header">{{ title }} </p-header>

            <div *ngIf="!importingState.success" class="content attachment-cont">
                <img *ngIf="importingState.showIcon"
                     src="assets/images/importing.png"
                     style="width: 67px; height: 67px"/>
                <img *ngIf="importingState.downloadAttachmentFileUrl || importingState.roId"
                     src="assets/images/service-provider/success.png"
                     style="width: 67px; height: 67px"/>
                <img *ngIf="importingState.showIcon || importingState.downloadIcon"
                     src="assets/images/landing-page/loading-more.svg"
                     alt="Loader"/>
                <div *ngIf="importingState.downloadIcon2" class="ro-loader">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <img *ngIf="importingState.error"
                     src="assets/images/common/error-msg-icon.png"
                     style="width: 67px; height: 67px"/>
                <span style="margin-top: 20px" class="file-name-text" [innerHTML]="importingState.text"></span>
                <a *ngIf="importingState.downloadAttachmentFileUrl"
                   pTooltip="Download Tool Primary Pictures"
                   tooltipPosition="bottom"
                   target="_blank"
                   [href]="exportAttachmentUrl"
                   class="add-action-btn-gray">
                    <img style="width: 9px"
                         class="tool-img"
                         src="assets/images/bug-details/attachment.png"
                         alt=""/>
                    Download File
                </a>
                <button *ngIf="importingState.downloadAttachmentFileUrl || importingState.error"
                        class="close-btn"
                        (click)="onClose()">
                    Close
                </button>

                <div *ngIf="importingState.roId" class="ro-btn-container mt-3">
                    <a [href]="'/repair-order/view/' + importingState.roId" target="_blank" class="btn primary">View RO</a>
                    <div class="btn outline" (click)="onClose()">
                        Close
                    </div>
                </div>

            </div>

            <div *ngIf="importingState.success" class="content attachment-cont">
                <img src="assets/images/login/verified-success.png"
                     style="width: 62px; height: 62px"/>
                <span style="margin-top: 20px" class="file-name-text">Tools imported successfully</span>
            </div>
        </p-accordionTab>
    </p-accordion>
</div>